<template>
  <component :is="tag"
             :class="[align, columns, offsets, orders]"
  >
    <slot/>
  </component>
</template>

<script>

export default {
  name: 'VCol',
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    alignSelf: String,
    cols: String,
    sm: String,
    md: String,
    lg: String,
    xl: String,
    xxl: String,
    offset: String,
    offsetSm: String,
    offsetMd: String,
    offsetLg: String,
    offsetXl: String,
    offsetXxl: String,
    order: String,
    orderSm: String,
    orderMd: String,
    orderLg: String,
    orderXl: String,
    orderXxl: String,
  },
  computed: {
    align() {
      return this.alignSelf ? `align-self${this.alignSelf}` : '';
    },
    columns() {
      let classes = '';

      classes += this.cols ? `col-${this.cols} ` : '';

      classes += this.sm ? `col-sm-${this.sm} ` : '';
      classes += this.md ? `col-md-${this.md} ` : '';
      classes += this.lg ? `col-lg-${this.lg} ` : '';
      classes += this.xl ? `col-xl-${this.xl} ` : '';
      classes += this.xxl ? `col-xxl-${this.xxl} ` : '';

      if (!classes) {
        return 'col'
      }

      return classes;
    },
    offsets() {
      let classes = '';

      classes += this.offset ? `offset-${this.offset} ` : '';
      classes += this.offsetSm ? `offset-sm-${this.offsetSm} ` : '';
      classes += this.offsetMd ? `offset-md-${this.offsetMd} ` : '';
      classes += this.offsetLg ? `offset-lg-${this.offsetLg} ` : '';
      classes += this.offsetXl ? `offset-xl-${this.offsetXl} ` : '';
      classes += this.offsetXxl ? `offset-xxl-${this.offsetXxl} ` : '';

      return classes;
    },
    orders() {
      let classes = '';

      classes += this.order ? `order-${this.order} ` : '';
      classes += this.orderSm ? `order-sm-${this.orderSm} ` : '';
      classes += this.orderMd ? `order-md-${this.orderMd} ` : '';
      classes += this.orderLg ? `order-lg-${this.orderLg} ` : '';
      classes += this.orderXl ? `order-xl-${this.orderXl} ` : '';
      classes += this.orderXxl ? `order-xxl-${this.orderXxl} ` : '';

      return classes;
    },
  }
};
</script>
